export function timeSince(milliseconds) {
    const seconds = Math.floor((Date.now() - milliseconds) / 1000);
    const intervals = [
        { label: 'years', value: 31536000 },
        { label: 'months', value: 2592000 },
        { label: 'days', value: 86400 },
        { label: 'hours', value: 3600 },
        { label: 'minutes', value: 60 },
        { label: 'seconds', value: 1 }
    ];
    for (const { label, value } of intervals) {
        if (seconds >= value) {
            return `${Math.floor(seconds / value)} ${label}`;
        }
    }
    return '0 seconds';
}